import * as angular from 'angular';
import { MixableBaseController } from '~/common/component';

class RunFailedErrorController {
  charType: string;

  handleChartType(chartType: string | undefined): string {
    if (chartType && chartType.toLowerCase().includes('table')) {
      return 'table';
    }

    return 'chart';
  }
}

export const RunFailedErrorComponent: angular.IComponentOptions = {
  bindings: {
    onSelectQuery: '&',
    chartType: '<',
  },
  controller: RunFailedErrorController,
  controllerAs: 'ctrl',
  template: `
    <div class="mode-placeholder broken">
      <div class="centered-content">
        <p><i class="icon-broken-viz" /></p>
        <p class="error-message">Sorry, this {{ctrl.handleChartType(ctrl.chartType)}} can't be displayed &mdash;<br/>there's an error in the source data</p>
        <!-- disabling this functionality for now, we currently don't have a way to link back to the query from the report view -->
        <!--<a href="javascript:void" ng-click="ctrl.onSelectQuery()">See what's wrong</a> -->
      </div>
    </div>`,
};
